module.exports = "<p>\n  test4 works!\n</p>\n"